import { render, staticRenderFns } from "./DriverInformation.vue?vue&type=template&id=e53f9e98&scoped=true"
import script from "./DriverInformation.vue?vue&type=script&lang=js"
export * from "./DriverInformation.vue?vue&type=script&lang=js"
import style0 from "./DriverInformation.vue?vue&type=style&index=0&id=e53f9e98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53f9e98",
  null
  
)

export default component.exports